<template>
  <div>
    <KanjiStudy />
  </div>
</template>

<script setup>
import KanjiStudy from '../components/KanjiStudy.vue';
</script>

<style scoped>
/* Minimal wrapper styles */
</style>
